import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	createPromocodeRegistryQuery,
	Promocode,
	PromocodeRegistryFilters,
	PromocodeRegistryQuery,
} from 'shared/api';
import { createRegistryModel, RegistryCallbacks, RegistryModel } from 'shared/lib';

type CreatePromocodeRegistryModelParams = {
	$voucherId: Store<number | null>;
	query?: PromocodeRegistryQuery;
} & RegistryCallbacks;

export type PromocodeRegistryModel = RegistryModel<
	Promocode,
	PromocodeRegistryFilters,
	JsonApiRequestError
>;

export const createPromocodeRegistryModel = ({
	$voucherId,
	query: queryOverride,
	...params
}: CreatePromocodeRegistryModelParams): PromocodeRegistryModel => {
	const query = queryOverride ?? createPromocodeRegistryQuery($voucherId);

	const model = createRegistryModel({
		query,
		filters: {
			statuses: [],
		},
		...params,
	});

	return model;
};
